module.exports = __webpack_public_path__ + "static/media/south_pole_pic1.51952976.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/south_pole_pic1.jpg
 ** module id = 479
 ** module chunks = 0
 **/